<div
  [matTooltip]="(tooltip$ | async) ?? ''"
  matTooltipPosition="above">
  <ng-container [ngSwitch]="status$ | async">
    <mat-icon
      *ngSwitchCase="employmentInviteeStatusEnum.OPEN"
      class="size-20 text-icon-grey"
      svgIcon="clock"></mat-icon>
    <mat-icon
      *ngSwitchCase="employmentInviteeStatusEnum.AVAILABLE"
      class="size-20 text-icon-success"
      svgIcon="check"></mat-icon>
    <mat-icon
      *ngSwitchCase="employmentInviteeStatusEnum.UNAVAILABLE"
      class="size-20 text-icon-error"
      svgIcon="close"></mat-icon>
    <mat-icon
      *ngSwitchCase="employmentInviteeStatusEnum.DECLINED"
      class="size-20 text-icon-error"
      svgIcon="close-rejected-remove-circle"></mat-icon>
    <mat-icon
      *ngSwitchCase="employmentInviteeStatusEnum.CANCELLED"
      class="size-20 text-icon-error"
      svgIcon="star-rejected-storno-filled"></mat-icon>
    <mat-icon
      *ngSwitchCase="employmentInviteeStatusEnum.BOOKED"
      class="size-20 text-icon-warning"
      svgIcon="star-filled"></mat-icon>
    <mat-icon
      *ngSwitchCase="employmentInviteeStatusEnum.POSSIBLE_CANDIDATE"
      class="size-20 text-icon-success"
      svgIcon="star-check-outline"></mat-icon>
  </ng-container>
</div>
